import { render } from "./withdraw-history.vue?vue&type=template&id=e580b39a&scoped=true"
import script from "./withdraw-history.vue?vue&type=script&lang=js"
export * from "./withdraw-history.vue?vue&type=script&lang=js"

import "./withdraw-history.vue?vue&type=style&index=0&id=e580b39a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e580b39a"]])

export default __exports__